import { PRIMARY_TRAVELLER_FORM_ID } from 'constants/checkout'
import createSelector from 'lib/createSelector'
import { getExperienceItems } from 'checkout/selectors/view/experience'
import { isNoProtectionInsuranceItem, isLEHotelItem } from 'lib/checkout'
import { OFFER_TYPE_HOTEL, PRODUCT_TYPE_ULTRALUX } from 'constants/offer'

export const getPrimaryTravellerForm = createSelector(
  (state: App.State) => state.checkout.form.travellerForms,
  (forms) => forms.find(form => form.id === PRIMARY_TRAVELLER_FORM_ID),
)

export const isStandaloneExperience = createSelector(
  (state: App.State) => state.checkout.cart.items,
  getExperienceItems,
  (cartItems, experienceItems): boolean => experienceItems.length === 1 && cartItems.length === 1,
)

export const cartIsEntirelyFlashHotels = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => state.offer.offers,
  (cartItems, offerMap): boolean => {
    return cartItems.every(item => (
      (isNoProtectionInsuranceItem(item)) ||
      (isLEHotelItem(item) &&
        offerMap[item.offerId]?.type === OFFER_TYPE_HOTEL &&
        offerMap[item.offerId]?.productType !== PRODUCT_TYPE_ULTRALUX
      )
    ))
  },
)
